import { type FC } from 'react'

import { useGlobalConfigContext } from '../../global-config'
import { TENANT } from '../../tenant'

const LIST_PRICE_SUPER_SCRIPT = 1

export const TosSuperscriptListPrice: FC<{ price: string }> = ({ price }) => {
  const { tenant } = useGlobalConfigContext()
  if (!price) {
    return null
  }

  if (tenant === TENANT.COM || tenant === TENANT.IT) {
    return <sup>{LIST_PRICE_SUPER_SCRIPT}</sup>
  }

  return null
}
